import { type PraticaDomandaDTO } from '@framework/api-client/api/backoffice/schemas/praticaDomandaDTO.ts';
import { type TipoDomandaDTO } from '@framework/api-client/api/inquiries-compile/schemas/tipoDomandaDTO.ts';
import { getStartableInquiryDates } from './getStartableInquiryDates.ts';
import { isInquiryTypeStartable } from './isInquiryTypeStartable.ts';

/**
 * Aggiunge a ogni tipo domanda le date di avvio definite nella pratica
 * (in base al gruppo) e scarta quelli non avviabili ad oggi.
 */
export function getStartableInquiries(
  inquiries: TipoDomandaDTO[],
  startableData: PraticaDomandaDTO[] | null | undefined,
) {
  return inquiries
    .map(inquiry => {
      const { startDate, endDate } = getStartableInquiryDates(
        startableData?.find(s => s.idGruppoTipoDomanda === inquiry.idGruppo),
      );

      return { ...inquiry, startDate, endDate };
    })
    .filter(inquiry =>
      isInquiryTypeStartable(inquiry.startDate, inquiry.endDate),
    );
}
